import { defineComponent as y, computed as d, openBlock as o, createBlock as r, unref as c, normalizeClass as b, withCtx as p, createElementVNode as k, resolveDynamicComponent as C, toRaw as B, mergeProps as z, createCommentVNode as s, createElementBlock as w } from "vue";
import { RevButtonBase as T } from "@ds/components/ButtonBase";
import { RevSpinner as D } from "@ds/components/Spinner";
import { tw as e } from "../../utils/tailwind.js";
import { SizesEnum as L } from "./ButtonIcon.constant.js";
const V = { class: "relative" }, I = /* @__PURE__ */ y({
  name: "RevButtonIcon",
  __name: "ButtonIcon",
  props: {
    ariaDescribedby: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaLabel: { default: void 0 },
    hasBadge: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    icon: {},
    loading: { type: Boolean, default: !1 },
    loadingAlternativeText: { default: void 0 },
    alternativeText: { default: void 0 },
    size: { default: "medium" },
    to: { default: void 0 },
    variant: {},
    tracking: { default: () => ({}) }
  },
  emits: ["click"],
  setup(t) {
    const a = t, u = d(() => a.disabled ? "" : a.to), g = d(() => {
      const n = [
        e`focus-visible-outline-default-hi rounded-full`,
        e`flex shrink-0 cursor-pointer appearance-none`,
        e`items-center justify-center`,
        e`no-underline`,
        e`disabled:cursor-not-allowed`,
        e`motion-safe:transition motion-safe:duration-300 motion-safe:ease-in`
      ], i = a.variant === "secondary" || a.variant === "secondaryDestructive" ? "" : e`border-0`, l = {
        medium: e`size-40`,
        small: e`size-32`
      }, x = {
        primary: [
          e`bg-action-default-hi text-onaction-default-hi`,
          e`hover:bg-action-default-hi-hover`,
          e`disabled:bg-action-default-hi-disabled disabled:text-onaction-default-hi-disabled`
        ],
        secondary: [
          e`bg-action-default-min text-action-default-hi`,
          e`border-action-default-low border border-solid`,
          e`hover:bg-action-default-min-hover`,
          e`disabled:bg-action-default-min-disabled disabled:border-action-default-low-disabled disabled:text-action-default-hi-disabled`
        ],
        primaryDestructive: [
          e`bg-action-danger-hi text-onaction-danger-hi`,
          e`hover:bg-action-danger-hi-hover`,
          e`disabled:bg-action-danger-hi-disabled disabled:text-onaction-danger-hi-disabled`
        ],
        secondaryDestructive: [
          e`bg-action-danger-min text-action-danger-hi`,
          e`border-action-danger-hi border border-solid`,
          e`hover:bg-action-danger-min-hover`,
          e`disabled:bg-action-danger-min-disabled disabled:border-action-danger-hi-disabled disabled:text-action-danger-hi-disabled`
        ],
        ghost: [
          e`bg-action-default-min text-action-default-hi`,
          e`hover:bg-action-default-min-hover`,
          e`disabled:bg-action-default-min-disabled disabled:text-action-default-hi-disabled`
        ],
        ghostDestructive: [
          e`bg-action-default-min text-action-danger-hi`,
          e`hover:bg-action-default-min-hover`,
          e`disabled:bg-action-default-min-disabled disabled:text-action-danger-hi-disabled`
        ],
        brand: [
          e`bg-action-brand-low text-onaction-brand-low`,
          e`hover:bg-action-brand-low-hover`,
          e`disabled:opacity-40`
        ]
      };
      return [n, i, l[a.size], x[a.variant]];
    }), f = d(() => a.hasBadge ? a.size === L.Medium ? "clip-path: path('M15.5293 0C14.5788 1.0616 14 2.46293 14 4C14 7.31371 16.6863 10 20 10C21.5371 10 22.9384 9.42118 24 8.4707V24H0V0H15.5293Z')" : "clip-path: path('M19 0C16.2386 0 14 2.23858 14 5C14 7.76142 16.2386 10 19 10C21.7614 10 24 7.76142 24 5V24H0V0H19Z')" : ""), m = d(() => {
      const n = [e`bg-static-danger-hi rounded-full absolute`], i = {
        medium: e`right-0 top-0 size-8`,
        small: e`right-2 top-2 size-6`
      };
      return [n, i[a.size]];
    }), h = d(() => ({ alternativeText: a.alternativeText })), v = d(() => a.loading && a.loadingAlternativeText ? a.loadingAlternativeText : a.ariaLabel ? a.ariaLabel : a.alternativeText);
    return (n, i) => (o(), r(c(T), {
      "aria-describedby": t.ariaDescribedby,
      "aria-label": v.value,
      "aria-labelledby": t.ariaLabelledby,
      class: b(g.value),
      disabled: t.disabled,
      to: u.value,
      tracking: t.tracking,
      onClick: i[0] || (i[0] = (l) => n.$emit("click", l))
    }, {
      default: p(() => [
        k("div", V, [
          t.loading ? s("", !0) : (o(), r(C(B(t.icon)), z({ key: 0 }, h.value, {
            "aria-hidden": "true",
            style: f.value
          }), null, 16, ["style"])),
          !t.loading && t.hasBadge ? (o(), w("div", {
            key: 1,
            "aria-hidden": "true",
            class: b(m.value)
          }, null, 2)) : s("", !0),
          t.loading ? (o(), r(c(D), {
            key: 2,
            "alternative-text": t.loadingAlternativeText
          }, null, 8, ["alternative-text"])) : s("", !0)
        ])
      ]),
      _: 1
    }, 8, ["aria-describedby", "aria-label", "aria-labelledby", "class", "disabled", "to", "tracking"]));
  }
});
export {
  I as default
};
